<template>
  <el-breadcrumb class="app-levelbar" separator="/">
    <span class="el-breadcrumb__item">您的位置：</span>
    <el-breadcrumb-item v-for="item in levelList" :key="item.permission">
      <router-link v-if="!item.permission" to="" class="no-redirect">{{item.name}}</router-link>
      <router-link v-else :to="{name: item.permission}">{{item.name}}</router-link>
    </el-breadcrumb-item>
  </el-breadcrumb>
</template>
<script type="text/ecmascript-6">
  export default {
    created() {
      this.getBreadcrumb();
    },
    data() {
      return {
        levelList: [],
        menuInfo: this.$store.getters.menuInfo
      }
    },
    methods: {
      getBreadcrumb() {
        if (this.$route.name == 'baseInfo' || this.$route.name == 'passManage') {
          this.levelList.push({name: '账号管理', permission: null});
          this.levelList.push({name: this.$route.meta.nav, permission: this.$route.name});
        } else {
          this.menuInfo.map((item) => {
            if (item.children) {
              let switchOne = 1;
              item.children.map((subItem) => {
                if (subItem.permission === this.$route.name) {
                  this.levelList.push({name: item.name, permission: item.permission});
                  this.levelList.push({name: subItem.name, permission: subItem.permission});
                } else if (this.$route.name.includes(subItem.permission) && this.$route.name!=='school_gava' && this.$route.name!=='school_info') {
                  if (switchOne === 1) {
                    this.levelList.push({name: item.name, permission: item.permission});
                    this.levelList.push({name: this.$route.name!=='school_infoOper' ? subItem.name : '学校信息', permission: this.$route.name!=='school_infoOper' ? subItem.permission : 'school_info'});
                    let name = this.getParamsType(this.$route.params.type);
                    this.levelList.push({name, permission: null});
                    switchOne+=1;
                  }
                }
              });
            } else {
              if (item.permission === this.$route.name) {
                this.levelList.push({name: item.name, permission: item.permission});
              }
            }
          })
        }
      },
      getParamsType(type) {
        let name = '';
        switch (type) {
          case 'add':
            name = '新增';
            break;
          case 'edit':
            name = '修改';
            break;
          case 'see':
            name = '查看';
            break;
          case 'transfer':
            name = '转辖区';
            break;
          case 'distribute':
            name = '分配角色';
            break;
          default:
            name = '';
            break;
        }
        return name;
      }
    },
    watch: {
      $route() {
        this.getBreadcrumb();
      }
    }
  }
</script>
<style lang="less" scoped>
  .app-levelbar {
    position: fixed;
    left: 170px;
    top: 50px;
    right: 0;
    z-index: 2;
    background: #ececec;
    transition: all .28s ease-out;
    font-size: 12px;
    line-height: 36px;
  }
  .no-redirect{
    color: #97a8be;
    cursor: text;
  }
  .hideSidebar {
    .app-levelbar{
      left: 30px !important;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/layout/levelbar.vue